import { BookmarksIcon } from '../../shared/ui/icons';
import { Meter } from '../../shared/ui/meter';
import { SectionPanel } from '../../shared/ui/section-panel';
import { formatBytes, keptBytes, storedKinds, useRetentionUsage } from '../../entities/retention';

/** Board S1, "What is stored": content by kind, history, and what is never removed. */
export const StorageContents = () => {
  const usage = useRetentionUsage();
  if (!usage.data) return null;

  const kinds = storedKinds(usage.data);
  const total = usage.data.totalBytes;

  return (
    <SectionPanel title="What is stored" note="each flow keeps these for its own period">
      {kinds.map((kind) => (
        <div
          key={kind.key}
          className="flex items-center gap-3 border-t border-border-sunken px-card py-flat first:border-t-0"
        >
          <div className="min-w-0 flex-1">
            <p className="text-data text-primary">{kind.title}</p>
            <p className="mt-hair text-meta leading-17 text-muted">{kind.note}</p>
          </div>
          <Meter
            value={total > 0 ? (kind.bytes / total) * 100 : 0}
            tone="motion"
            className="w-storage-meter shrink-0"
          />
          <div className="w-col-keeps shrink-0 text-right">
            <p className="font-mono text-meta text-primary">{formatBytes(kind.bytes)}</p>
            <p className="font-mono text-micro text-faint">
              {kind.rows.toLocaleString('en-US')} {kind.unit}
            </p>
          </div>
        </div>
      ))}
      <div className="flex items-center gap-inset border-t border-border-sunken bg-field-muted px-card py-flat text-meta text-muted">
        <BookmarksIcon size="sm" />
        <span>
          Issues and bookmarks are never removed automatically —{' '}
          {formatBytes(keptBytes(usage.data))}. They stay until you delete them.
        </span>
      </div>
    </SectionPanel>
  );
};
